<template>
  <UiModal
    class="onboarding"
    ref="modal"
    dismiss-on="close-button esc"
    @close="dismountMe()"
  >
    <h2 class="header" slot="header">Шаг {{ step }}</h2>
    <slider
      @slideChange="index => (step = index + 1)"
      @sliderReady="slider => (flickity = slider)"
      class="slider"
      :options="options"
    >
      <div class="slide" :key="index" v-for="(slide, index) in slides">
        <div class="image">
          <img :src="slide.image" alt="" />
        </div>
        <div class="description">
          <h3>
            {{ slide.heading }}
          </h3>
          <p>
            {{ slide.text }}
          </p>
        </div>
      </div>
    </slider>
    <div class="modal-footer">
      <UiButton @click="close()" type="secondary" color="primary"
        >Пропустить</UiButton
      >
      <UiButton v-if="!lastSlide" @click="next()" color="primary">
        Дальше
      </UiButton>
      <UiButton v-else @click="close()" color="green">
        Закрыть
      </UiButton>
    </div>
  </UiModal>
</template>
<script>
import { UiModal, UiButton } from "keen-ui";
import slider from "@/components/flickitySlider";

export default {
  components: {
    UiModal,
    UiButton,
    slider
  },
  data() {
    return {
      flickity: null,
      step: 1,
      options: {
        contain: true,
        wrapAround: true,
        pageDots: true,
        percentPosition: true,
        draggable: false,
        prevNextButtons: false,
        adaptiveHeight: true
      },
      lastSlide: false,
      slides: [
        {
          image: require("@/assets/img/onboarding/1.jpg"),
          heading: "Выбор шаблона",
          text:
            "Выберите дизайн вашей страницы из подборки готовых шаблонов. Шаблоны представлены в нескольких категориях и имеют разный стиль. Воспользуйтесь «Предпросмотром», чтобы увидеть, как будет выглядеть страница. При необходимости вы сможете изменить внешний вид страницы в любой момент."
        },
        {
          image: require("@/assets/img/onboarding/2.jpg"),
          heading: "Выбор и редактирование компонентов",
          text:
            "Следующий шаг — выбор и редактирование компонентов страницы. Компонент «Контакты» обязателен к заполнению, а другие компоненты можно включить и настроить по желанию. После настройки компонентов используйте «Предпросмотр», чтобы увидеть, как выглядит ваша страница."
        },
        {
          image: require("@/assets/img/onboarding/3.jpg"),
          heading: "Публикация страницы",
          text:
            "Завершающим этапом создания страницы является публикация. После публикации вы сможете скопировать адрес вашей страницы, чтобы отправить друзьям, либо поделиться ссылкой в социальных сетях. Один зарегистрированный пользователь может опубликовать только одну страницу."
        },
        {
          image: require("@/assets/img/onboarding/4.jpg"),
          heading: "Дальнейшее редактирование страницы",
          text:
            "Опубликованная страница станет главной страницей вашего профиля. Вы в любой момент сможете вернуться к редактированию, добавить и изменить компоненты страницы. При необходимости созданную страницу снять с публикации."
        },
        {
          image: require("@/assets/img/onboarding/5.jpg"),
          heading: "Личный кабинет",
          text:
            "В личном кабинете вы всегда сможете изменить имя, фамилию, пароль и адрес электронной почты для связи с вами, а также загрузить новый аватар."
        }
      ]
    };
  },
  methods: {
    next() {
      this.flickity.next();
      if (this.flickity.selectedIndex === this.slides.length - 1)
        this.lastSlide = true;
    },
    close() {
      this.$refs.modal.close();
    },
    dismountMe() {
      this.$emit("close");
    }
  },
  mounted() {
    this.$refs.modal.open();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.onboarding {
  /deep/ .ui-modal__body {
    position: relative;
  }
}

.description {
  text-align: left;
  width: 50%;
  padding-left: 20px;
  h3 {
    margin-top: 0;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: normal;
    font-size: 34px;
    letter-spacing: 0.25px;
    @media #{$mobile} {
      font-size: 24px;
    }
  }
  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 24px;
    font-size: 16px;
    letter-spacing: 0.15px;
    @media #{$mobile} {
      font-size: 14px;
    }
  }
}

.slider {
  margin: 0 30px;
  padding: 50px 0 90px 0;
  /deep/ .flickity-page-dots {
    bottom: 30px;
    text-align: left;
    @media #{$mobile} {
      bottom: 60px;
      left: 5%;
    }
  }
  width: 1024px;
  @media #{$tablet} {
    width: 705px;
  }
  @media #{$mobile} {
    width: 430px;
    margin-left: 30px;
  }
  .slide {
    align-items: flex-start;
    justify-content: center;
    display: flex;
    width: 100%;
    @media #{$mobile} {
      flex-flow: column nowrap;
    }
    .image {
      padding: 0 0 20px 0;
      width: 50%;
    }
    img {
      max-width: 100%;
    }
  }
}

.header {
  text-align: center;
  width: 100%;
}

.modal-footer {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 10px;
  @media #{$mobile} {
    flex-flow: column nowrap;
    bottom: -2px;
  }
  button {
    margin: 0 10px;
  }
}
</style>
